import { getCookie, read } from "./storage";
import { ReadCache } from "./queryCache";

// Never persist API data. Token rotation, sign-out, or account/company changes
// invalidate the memory cache before another response can be reused.
export const readCache = new ReadCache(() => {
  let account: { id?: string; company?: unknown } = {};
  try {
    account = JSON.parse(read("account") || "{}");
  } catch {
    /* no saved account */
  }
  return JSON.stringify([getCookie("access"), account?.id, account?.company]);
});
